'use client';

import qs from 'query-string';
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useCallback } from "react";
import { IconType } from "react-icons";
import { getCategoryDisplayLabel } from "@/app/libs/categoryDisplayLabel";

interface CategoryBoxProps {
  icon: IconType,
  label: string;
  selected?: boolean;
}

const CategoryBox: React.FC<CategoryBoxProps> = ({
  icon: Icon,
  label,
  selected,
}) => {
  const router = useRouter();
  const pathname = usePathname();
  const params = useSearchParams();
  /** Visible text only; `label` stays the stored category value used in the query. */
  const displayLabel = getCategoryDisplayLabel(label);

  const handleClick = useCallback(() => {
    let currentQuery = {};
    
    if (params) {
      currentQuery = qs.parse(params.toString())
    }

    const updatedQuery: any = {
      ...currentQuery,
      category: label
    }

    if (params?.get('category') === label) {
      delete updatedQuery.category;
    }

    const basePath = pathname === '/search' ? '/search' : '/';
    const url = qs.stringifyUrl({
      url: basePath,
      query: updatedQuery
    }, { skipNull: true });

    router.push(url);
  }, [label, router, params, pathname]);

  return ( 
    <div
      onClick={handleClick}
      className={`
        shrink-0
        flex 
        flex-col 
        items-center 
        justify-center 
        gap-1 md:gap-1.5
        py-1.5 px-1.5 md:py-2 md:px-2
        border-b-2
        hover:text-neutral-800
        transition
        cursor-pointer
        ${selected ? 'border-b-neutral-800' : 'border-transparent'}
        ${selected ? 'text-neutral-800' : 'text-neutral-500'}
      `}
    >
      <Icon className="shrink-0 h-[22px] w-[22px] md:h-6 md:w-6" />
      <div
        className={`font-medium text-[11px] md:text-sm text-center leading-tight ${
          displayLabel !== label ? 'max-w-[92px] md:max-w-[120px]' : ''
        }`}
      >
        {displayLabel}
      </div>
    </div>
   );
}
 
export default CategoryBox;